var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4375 6.75C17.4375 7.34674 17.2004 7.91903 16.7785 8.34099C16.3565 8.76295 15.7842 9 15.1875 9",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5.625H9.75",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78506 7.875C4.74428 7.86831 4.70253 7.87058 4.66271 7.88164C4.6229 7.8927 4.58596 7.91228 4.55446 7.93904C4.52297 7.96579 4.49767 7.99908 4.48032 8.03658C4.46297 8.07409 4.45398 8.11492 4.45398 8.15625C4.45398 8.19757 4.46297 8.2384 4.48032 8.27591C4.49767 8.31341 4.52297 8.3467 4.55446 8.37345C4.58596 8.40021 4.6229 8.41979 4.66271 8.43085C4.70253 8.44191 4.74428 8.44418 4.78506 8.4375C4.85177 8.42657 4.91242 8.39228 4.95619 8.34076C4.99995 8.28924 5.02398 8.22384 5.02398 8.15625C5.02398 8.08865 4.99995 8.02325 4.95619 7.97173C4.91242 7.92021 4.85177 7.88593 4.78506 7.875",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.925 3.285C5.0475 1.695 2.8125 1.6875 2.8125 1.6875L3.285 4.9725C2.66644 5.6398 2.20966 6.44044 1.95 7.3125H0.5625V11.8125H2.43C2.81578 12.4927 3.32438 13.0954 3.93 13.59V15.75C3.93194 15.8986 3.99183 16.0405 4.0969 16.1456C4.20197 16.2507 4.34392 16.3106 4.4925 16.3125H5.625C5.77358 16.3106 5.91553 16.2507 6.0206 16.1456C6.12567 16.0405 6.18556 15.8986 6.1875 15.75V14.82C7.64829 15.305 9.22671 15.305 10.6875 14.82V15.75C10.6894 15.8986 10.7493 16.0405 10.8544 16.1456C10.9595 16.2507 11.1014 16.3106 11.25 16.3125H12.375C12.5236 16.3106 12.6655 16.2507 12.7706 16.1456C12.8757 16.0405 12.9356 15.8986 12.9375 15.75V13.605C13.6317 13.0534 14.194 12.3536 14.5833 11.5569C14.9725 10.7602 15.179 9.88667 15.1875 9C15.1875 4.1325 9.9 1.9575 5.925 3.285Z",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPig);
export default __webpack_public_path__ + "static/media/pig.f4542969403d5d13cdb12b1a5e76ef22.svg";
export { ForwardRef as ReactComponent };